// playground requires you to assign document definition to a variable called dd
/* eslint-disable */
import moment from 'moment'
import config from '@/config'
var dd = {
    header: {                                     
		margin: [ 0, 10, 20, 40 ], 
		text: `Date: ${moment(Date.now()).format('DD/MM/YYYY')}`,
		alignment: 'right',
		style: 'smallText'             
	},
	footer: {            
			margin: [ 0, 10, 0, 10 ],
			text: 'www.getkobe.com', 
			alignment: 'center',
			style: 'smallText'
	},
	content: [
		{
      // if you specify both width and height - image will be stretched
      image: config.kobeLogoDataURL,
      width: 160,
      alignment: 'center'
    },		
	{ alignment: 'justify',
	  margin: [0, 20, 0, 0],
      columns: [
       [
           {text: 'Kobe Global Technologies Pte Ltd.'},
           {text: 'GST Registration no. 201608755R'},
           {text: '51 Goldhill Plaza'},
           {text: '#14-01'},
           {text: 'Singapore 308900'},
           {text: 'finance@getkobe.com'}
        ],
        [
           
        ]
        ]
	  
	},
	{
	    margin: [0, 20, 0, 0],
	    table: {
				widths: ['100%'],
				body: [
					[{text: 'Content Creator Details', style: 'tableHeader', alignment: 'left'}],
				    [{text: 'Instagram Handle: @XXX', border: [true, true, true, true]}]
				]
			}
	},
	{
	    margin: [0, 20, 0, 0],
	    table: {
				widths: ['100%'],
				// keepWithHeaderRows: 1,
				body: [
				
					[{text: 'Company Rep Details', style: 'tableHeader', alignment: 'left'}],
				    [{text: 'Kobe Global Technologies Pte Ltd.',bold: true, border: [true, true, true, false]}],
				    [{text: '(+65) 6255 5662', border: [true, false, true, false]}],
				    [{text: 'finance@getkobe.com', border: [true, false, true, true]}]
				]
			}
	},
	{
	    margin: [0, 20, 0, 0],
	    table: {
				widths: ['100%'],
				body: [
					[{text: 'Campaign Details', style: 'tableHeader', alignment: 'left'}],
				    [{text: 'Campaign Name-QuarterYear-COUNTRY',bold: true, border: [true, true, true, false]}],
				    [{text: 'Campaign Ref: XXX', border: [true, false, true, true]}]
				]
			}
	},
	{
	    margin: [0, 20, 0, 0],
	    table: {
				headerRows: 1,
				widths: ['70%', '10%', '20%'],
				body: [				
					[{text: 'DESCRIPTION', style: 'tableHeader', alignment: 'center'}, {text: 'QTY', style: 'tableHeader', alignment: 'center'}, {text: 'AMOUNT', style: 'tableHeader', alignment: 'center'}],
					[{text: 'Agreed Deliverables eg. IG REELS / TikTok Video / Youtube Shorts'}, {text: 'XX', alignment: 'center'}, {text: 'SGD XXX', alignment: 'center'}]
				]
			}
	},
	{ margin: [0, 40, 0, 0],
	  text: 'Terms and Conditions',
	  fontSize: 18
	},{
	    margin: [0, 10, 0, 0],
	    fontSize: 10,
	    ol: [
	      'I have read and accepted the terms of use (https://www.getkobe.com/influencer-terms-use-agreement/)',
	      'I have read and understood supporting campaign details that accompany this brief.',
	      'I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.',
	      'I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.',
	      'I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.',
	      'Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance, I may forfeit my rate or be deducted a penalty by the client.',
	      'I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.',
	      'I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.',
				'I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.',
				'If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.',
				'The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.'
	    ]
	},
	],
	styles: {
		header: {
			fontSize: 18,
			bold: true,
			margin: [0, 0, 0, 10]
		},
		subheader: {
			fontSize: 16,
			bold: true,
			margin: [0, 10, 0, 5]
		},
		tableExample: {
			margin: [0, 5, 0, 15]
		},
		tableHeader: {
			bold: true,
			fontSize: 13,
			color: 'white',
			fillColor: '#3F3FFF'
		},
		smallText: {
			fontSize: 9
		}
	},
	defaultStyle: {
		font: 'Arial'
		// alignment: 'justify'
	}
	
}

export default dd



// WEBPACK FOOTER //
// ./src/components/views/Contract/Influencer_contract.js